import { create } from 'zustand';

import { Gateway } from '@app-types/payment.type';
import { paymentsSDK } from '@services/payments';
import { Currency } from '@app-types/currency.type';

type State = {
    gateways: Gateway[];
    currencies: Currency[];
    exchangeRates: Record<string, number>;

    fetchCurrencies: () => Promise<void>;
    fetchGateways: (params?: { isActive?: true }) => Promise<void>;
    fetchCurrencyExchanges: (oauthToken: string) => Promise<void>;
};

const usePaymentsStore = create<State>((set) => ({
    gateways: [],
    currencies: [],
    exchangeRates: {},

    fetchCurrencies: async () => {
        const currencies = await paymentsSDK.admin.currencies.get();
        set({ currencies });
    },
    fetchGateways: async (params) => {
        const gateways = await paymentsSDK.admin.gateways.get(params);
        set({ gateways });
    },
    fetchCurrencyExchanges: async (oauthToken: string) => {
        const exchanges = await paymentsSDK.v2.getCurrencyExchange(oauthToken);
        const rates: Record<string, number> = {};
        for (const exchange of exchanges) {
            rates[exchange.currency] = exchange.rate;
        }
        set({ exchangeRates: rates });
    },
}));

export { usePaymentsStore };
